import { render, staticRenderFns } from "./userGroup.vue?vue&type=template&id=6865adba&scoped=true&"
import script from "./userGroup.vue?vue&type=script&lang=js&"
export * from "./userGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6865adba",
  null
  
)

export default component.exports